import { render, staticRenderFns } from "./PageJustView.vue?vue&type=template&id=34ea23fb&scoped=true&"
import script from "./PageJustView.vue?vue&type=script&lang=js&"
export * from "./PageJustView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ea23fb",
  null
  
)

export default component.exports